import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton } from "@mui/material";

import { CreatePostArrowBackIcon } from "../../assets/icons/create-feed";

import CreatePostForm from "./components/CreatePostForm";
import HowItWorks from "./components/HowItWorks";

const CreatePostPage = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #E7E7E7",
        background: "rgba(255, 255, 255, 0.90)",
        width: "100%",
        padding: "24px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
      }}
    >
      <IconButton sx={{ width: "fit-content" }} onClick={() => navigate("/feed")}>
        <CreatePostArrowBackIcon />
      </IconButton>
      {activeStep === 0 && <HowItWorks handleNext={handleNext} />}
      {activeStep === 1 && <CreatePostForm />}
    </Box>
  );
};

export default CreatePostPage;
